import { useMemo } from 'react';

type StorageOperation = {
  // sessionStorage 或者 localStorage
  storage: Storage;
  // 缓存的key值
  storageKey: string;
  // 模式：合并还是覆盖
  model?: 'merge' | 'cover';
  // 没有获取到数据的时候的默认值
  defaultValue: any;
  // 只能使用一次
  onlyUseOnce?: boolean;
};

export default function useStorageOperation({
  storage,
  storageKey,
  model = 'merge',
  defaultValue,
  onlyUseOnce = false,
}: StorageOperation) {
  function dealwithObject(data: any, historyObj: any) {
    const dataIsArr = Array.isArray(data);
    const hisIsArr = Array.isArray(historyObj);
    //  都是数组,那么就合并后返回
    if (dataIsArr && hisIsArr) {
      return historyObj.concat(data);
    }
    // 如果是数组与对象，那么就将数组放在对象的storageKey下
    if ((dataIsArr && !hisIsArr) || (!dataIsArr && hisIsArr)) {
      let obj = historyObj;
      let value = data;
      if (hisIsArr) {
        obj = data;
        value = historyObj;
      }
      return (obj[storageKey] = value);
    }
    // 对象就将其合并（浅拷贝）
    return Object.assign(historyObj, data);
  }
  const setStore = (data: any) => {
    const history = storage.getItem(storageKey);
    // 如果事覆盖或者获取到的值为null【没有设置的情况】，那么就不用管别的，直接设置上去就可以了
    if (model === 'cover' || history === null) {
      return storage.setItem(storageKey, JSON.stringify(data));
    }
    try {
      const historyObj = JSON.parse(history);
      // historyObj 数字，对象，数组
      if (typeof historyObj === 'object' && typeof data === 'object') {
        const saveInfo = dealwithObject(data, historyObj);
        return storage.setItem(storageKey, JSON.stringify(saveInfo));
      }
    } catch (error) {
      // 如果这个操作报错了，那么该数据就是字符串
    }

    // 其他的不管模式就是替换
    return storage.setItem(storageKey, history);
  };
  const getStore = () => {
    const history = storage.getItem(storageKey);
    try {
      const result = JSON.parse(history!);
      return result || defaultValue;
    } catch (error) {
    } finally {
      if (onlyUseOnce) {
        removeStore();
      }
    }
    // 其他的不管模式就是替换
    return history || defaultValue;
  };

  const removeStore = () => {
    storage.removeItem(storageKey);
  };

  const data = useMemo(() => {
    return getStore();
  }, []);

  return {
    data,
    getStore,
    setStore,
    removeStore,
  };
}
